export const getCodeMirrorOptions = (filename) => {
  const ext = filename.split('.').pop();
  switch (ext) {
  case 'js':
    return {
      mode: 'text/javascript',
      lineNumbers: true,
      lineWrapping: true,
      foldGutter: true,
      extraKeys: {
        Tab: 'emmetExpandAbbreviation',
        Esc: 'emmetResetAbbreviation',
        Enter: 'emmetInsertLineBreak',
      },
      gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
    }
  case 'css':
    return {
      mode: 'text/css',
      lineNumbers: true,
      lineWrapping: true,
      extraKeys: {
        Tab: 'emmetExpandAbbreviation',
        Esc: 'emmetResetAbbreviation',
        Enter: 'emmetInsertLineBreak',
      },
      foldGutter: true,
      gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
    }
  case 'twig':
    return {
      mode: {
        name: 'twig',
        base: 'text/html',
      },
      lineNumbers: true,
      profile: 'xhtml',
      lineWrapping: true,
      autoCloseBrackets: true,
      autoCloseTags: true,
      emmet: true,
      extraKeys: {
        // eslint-disable-next-line func-names
        'Ctrl-Q': function (cm) {
          cm.foldCode(cm.getCursor());
        },
        Tab: 'emmetExpandAbbreviation',
        Esc: 'emmetResetAbbreviation',
        Enter: 'emmetInsertLineBreak',
      },
      foldGutter: true,
      gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
    }
  default:
    return {
      mode: 'text/html',
      lineNumbers: true,
      lineWrapping: true,
      extraKeys: {
        Tab: 'emmetExpandAbbreviation',
        Esc: 'emmetResetAbbreviation',
        Enter: 'emmetInsertLineBreak',
      },
      foldGutter: true,
      gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
    }
  }
}
